<template>
  <div class="tab-content-five__container">
    
    <!-- head -->
    <div class="content__head">
      <h2 class="content__head-title">{{ diagnosticTest.title }}</h2>
      <p class="content__head-text" v-html="$convertPxToRem(diagnosticTest.content)"></p>
    </div>

    <!-- banner -->
    <!-- <div class="content__banner flex f-jus-center">
      <el-carousel
        :interval="3000"
        indicator-position="none"
        arrow="always"
        :autoplay="false"
        :loop="true"
      >
        <el-carousel-item v-for="(item, idx) in bannerList" :key="idx">
          <div class="content__banner__item-box flex f-center">
            <img :src="item" class="content__banner__item-img" />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div> -->

    <div class="banner-swiper">
      <!-- Swiper -->
      <div class="swiper-container swiper banner-container">
        <div class="swiper-wrapper">
          <template v-if="bannerList && bannerList.length > 0">
            <div class="swiper-slide" v-for="(item, i) in bannerList" :key="i" style="width:100%;">
              <img :src="item" alt="" />
            </div>
          </template>
          <div class="swiper-slide" style="width:100%;" v-else>
            <el-image>
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </div>
        <!-- 分页器 -->
        <div class="swiper-pagination"></div>
        <!-- 导航按钮 -->
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>

    <!-- grid menu -->
    <div class="content__grid-menu flex f-center">
      <div class="content__grid-menu__body flex f-wrap f-jus-between">
        <div
        class="content__grid-menu__item flex f-column f-ali-center"
        v-for="(title, i) in diagnosticTest.grid_menu_title"
        :key="i">
          <img src="../../../../assets/images1/customer_service/khfw23-1.png" class="content__grid-menu__icon" v-if="(i + 1) === 1" />
          <img src="../../../../assets/images1/customer_service/khfw23-2.png" class="content__grid-menu__icon" v-else-if="(i + 1) === 2" />
          <img src="../../../../assets/images1/customer_service/khfw23-3.png" class="content__grid-menu__icon" v-else-if="(i + 1) === 3" />
          <img src="../../../../assets/images1/customer_service/khfw23-4.png" class="content__grid-menu__icon" v-else-if="(i + 1) === 4" />
          <img src="../../../../assets/images1/customer_service/khfw23-5.png" class="content__grid-menu__icon" v-else-if="(i + 1) === 5" />
          <img src="../../../../assets/images1/customer_service/khfw23-6.png" class="content__grid-menu__icon" v-else-if="(i + 1) === 6" />
          <img src="../../../../assets/images1/customer_service/khfw23-7.png" class="content__grid-menu__icon" v-else-if="(i + 1) === 7" />
          <img src="../../../../assets/images1/customer_service/khfw23-8.png" class="content__grid-menu__icon" v-else-if="(i + 1) === 8" />
          <!-- title -->
          <h3 class="content__grid-menu__title">{{ title }}</h3>
        </div>
      </div>
    </div>

    <!-- rights -->
    <div class="content__rights flex f-column f-center">
      <!-- img -->
      <div class="content__rights-img"></div>
      <!-- list -->
      <ul class="flex f-jus-center">
        <li
        class="content__rights-item"
        v-for="(rights, i) in diagnosticTest.rights_list"
        :key="i">
        <h3 class="content__rights-item__title">
          <span style="padding-right:2px;">●</span>
          <span>{{ diagnosticTest.rights_list_title }}</span>
        </h3>
          <p class="content__rights-item__txt">{{ rights }}</p>
        </li>
      </ul>
    </div>
    <footer-wrap></footer-wrap>
  </div>
</template>

<script>
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
import { mapGetters } from 'vuex'

export default {
    name: 'TabContentFive',

    data() {
        return {
          bannerList: [
            require('../../../../assets/images1/customer_service/khfw22.jpg'),
            require('../../../../assets/images1/customer_service/khfw22_2.png'),
            require('../../../../assets/images1/customer_service/khfw22_1.jpg'),
          ]
        }
    },

    computed: {
      ...mapGetters([
        'currentLang'
      ]),
      diagnosticTest() {
        return this.currentLang.config.customerServicePage.diagnosticTest
      },
    },

    created() {

    },

    mounted() {
      this.initSwiper();
    },

    methods: {
      // 初始化 swiper
      initSwiper() {
        const bannerSwiper = new Swiper(".banner-container", {
          autoplay: {
            delay: 3000,
          },
          speed: 1100,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      },
    }
}
</script>

<style scoped lang="scss">
.content__head {
  width: 1000px;
  height: auto;
  margin: 50px auto 80px;
  text-align: center;

  h2 {
    color: #323232;
    font-weight: normal;
    margin-bottom: 30px;
    font-size: 30px;
  }

  p {
    color: #777777;
  }

  .content__head-text {
    line-height: 1.8;
    font-size: 18px;
    color: #777;
    text-align: justify;
    text-align-last: center;
  }
}

.content__banner {
  position: relative;
  width: 100%;
  // width: 1000px;
  height: 600px;
  margin: auto;
  margin-bottom: 100px;
  background-color: #fff;
  // background-color: red;

  .content__banner__item-box {
    width: 100%;
    height: 600px;
    background-color: #fff;
  }

  .content__banner__item-img {
    width: 1000px;
    height: 600px;
  }
}


.content__grid-menu {
  width: 100%;
  min-height: 500px;
  background-color: #F5F5F5;

  .content__grid-menu__body {
    width: 1100px;
  }

  .content__grid-menu__item {
    width: 240px;
    line-height: 2;
    text-align: center;
  }
  .content__grid-menu__item:nth-child(n + 5) {
    margin-top: 80px;
  }

  .content__grid-menu__icon {
    width: 60px;
    height: 60px;
    margin-bottom: 24px;
  }
  .content__grid-menu__title {
    color: #0F335E;
    font-size: 18px;
    font-weight: 500;
  }
}

.content__rights {
  width: 100%;
  height: 660px;

  .content__rights-img {
    margin-bottom: 50px;
    width: 658px;
    height: 308px;
    background: url("../../../../assets/images1/customer_service/khfw24.jpg") no-repeat scroll;
    background-position: center center;
    background-size: cover;
  }

  .content__rights-list {
    width: 100%;
    height: 310px;
  }

  .content__rights-item {
    width: 340px;
    margin-right: 50px;
    text-align: center;
  }
  .content__rights-item:last-child {
    margin-right: 0;
  }

  .content__rights-item__title {
    margin-bottom: 20px;
    font-size: 22px;
    font-weight: 500;
    letter-spacing: 1px;
    color: #0F335E;
  }

  .content__rights-item__txt {
    color: #777;
    line-height: 1.6;
    text-align: center;
    font-size: 18px;
  }

}


.banner-swiper {
  width: 100%;
  height: 600px;
  margin-bottom: 80px;

  .swiper-container {
    width: 100%;
    height: 100%;
  }
  
  .swiper-wrapper {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
  }

  .swiper-slide-item {
    width: 100%;
    height: 100%;
  }

  img {
    width: 100%;
    width: 1000px;
    height: 100%;
  }

  .swiper-button-next, .swiper-button-prev {
    color: rgba(0, 0, 0, 0.8);
  }
  
  .swiper-pagination-bullet-active {
    background: var(--main-color)!important;
  } 
}
</style>


// WEBPACK FOOTER //
// src/pages/home/home_customer_service/components/TabContentFive.vue